"use client";

import { useRef, useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurAgents() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const agents = [{
    id: 1,
    name: "PAM",
    role: "Project Admin Map",
    tagline: "Expert in project oversight and team coordination",
    image: "https://crack-rhino.10web.cloud/wp-content/uploads/2026/02/PAM.png?v=39d869awtv8"
  }, {
    id: 2,
    name: "SAM",
    role: "Scope Analysis Module",
    tagline: "Specialized in detecting scope gaps and project vitals",
    image: "https://crack-rhino.10web.cloud/wp-content/uploads/2026/02/SAM.png?v=o4dijk4p4pd"
  }, {
    id: 3,
    name: "BEN",
    role: "Compliance Specialist",
    tagline: "Ensures project adherence to standards and regulations",
    image: "https://crack-rhino.10web.cloud/wp-content/uploads/2026/02/BEN.png?v=11llo1vqj3n"
  }, {
    id: 4,
    name: "VIC",
    role: "Subcontractor Optimization Lead",
    tagline: "Optimizes subcontractor performance through data analytics",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536499/img/agent_vic_portrait.png"
  }, {
    id: 5,
    name: "ART",
    role: "AI & Tech Development",
    tagline: "Leads AI integration and platform innovation",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536499/img/agent_art_portrait.png"
  }];
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const handleScroll = () => {
      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth - container.clientWidth;
      const progress = scrollWidth > 0 ? scrollLeft / scrollWidth * 100 : 0;
      setScrollProgress(progress);
    };
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="our-agents" ref={sectionRef} className="bg-dark-background py-16 md:py-24 overflow-hidden" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(1rem)",
    transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), transform 200ms cubic-bezier(0.4, 0, 0.2, 1)"
  }}>
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-foreground-dark text-3xl md:text-4xl font-display font-bold text-center mb-6">
          Our Agents
        </h2>

        <p className="text-foreground-dark text-center max-w-3xl mx-auto mb-12 text-base md:text-lg leading-relaxed">
          AMPKORE has 5 agents. PAM Project Admin Map, Sam Scope Alignment Manager, BEN Bid Evaluator Network, VIC Value Intake Compliance, ART Active Review Tracking.
        </p>

        <div ref={scrollContainerRef} className="flex gap-6 overflow-x-auto snap-x snap-mandatory scrollbar-hide pb-8" style={{
        scrollbarWidth: "none",
        msOverflowStyle: "none"
      }}>
          {agents.map((agent, i) => <Card key={agent.id} data-index={i} className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 pt-0 bg-background min-w-[280px] snap-center flex-shrink-0 hover-lift !w-[200px] !h-[400px] md:min-w-[320px]">
              <CardContent className="p-0">
                <div className="aspect-[3/4] overflow-hidden rounded-t-xl">
                  <img src={agent.image} alt={agent.name} className="object-cover !w-[250px] !h-[300px]" />
                </div>
                <div className="p-6 space-y-2">
                  <h3 className="text-foreground text-2xl font-display font-bold">
                    {agent.name}
                  </h3>
                  <p className="text-primary text-sm font-semibold">
                    {agent.role}
                  </p>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {agent.tagline}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-8 max-w-md mx-auto px-4">
          <Progress value={scrollProgress} className="h-1" />
        </div>
      </div>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>;
}